import phrases from "./dorotheePhrases.json";

const groups = {
  open: [1, 2, 3, 4, 8, 28, 29, 45, 47, 48],
  question: [6, 7, 9, 11, 12, 13, 14, 16, 36, 37, 38, 39, 41, 42, 43, 44, 46, 49],
  after: [8, 16, 31, 32, 33, 34, 38, 49],
  click: [1, 2, 3, 4, 8, 28, 29, 45, 47, 48],
  idle: [1, 3, 4, 8, 28, 29, 31, 36, 44, 45, 47, 48],
};
const consultations = [5, 10, 15, 20, 25, 30, 35, 40, 50];
const yoda = [21, 22, 23, 24, 26, 27];
let state;
try { state = JSON.parse(sessionStorage.getItem("dl-phrases-v2") || "null"); } catch {}
state = state || { recent: [], last: 0, exchanges: 0, consultation: 0, cat: 0 };
function save() { try { sessionStorage.setItem("dl-phrases-v2", JSON.stringify(state)); } catch {} }
export function pickPhrase(moment, question = "") {
  const now = Date.now();
  if (moment === "question") state.exchanges += 1;
  const sensitive = /deuil|défunt|defunt|décès|deces|souffr|triste|mort|angoiss|maladie|santé/i.test(question);
  if (moment !== "click" && now - state.last < 18000) { save(); return null; }
  if ((moment === "question" || moment === "after") && Math.random() > 0.5) { save(); return null; }
  let pool = groups[moment] || groups.idle;
  if (sensitive) pool = [8, 16, 47, 49];
  if (moment === "question" && question.trim().length < 12 && !sensitive) pool = [17, 18, 19, 28];
  const personal = /je |j’|j'|mon |ma |mes |moi|personnel|famille|relation/i.test(question);
  if (moment === "after" && personal && state.exchanges >= 8 && now - state.consultation > 900000 && Math.random() < 0.08) {
    pool = consultations; state.consultation = now;
  } else {
    const cat = document.getElementById("dl-cat-wrap");
    if (!sensitive && cat && Number(getComputedStyle(cat).opacity) > 0.05 && now - state.cat > 900000 && Math.random() < 0.04) {
      pool = yoda; state.cat = now;
    }
  }
  let available = pool.filter(id => !state.recent.includes(id));
  if (!available.length) { save(); return null; }
  const id = available[Math.floor(Math.random() * available.length)];
  state.recent = [...state.recent, id].slice(-14); state.last = now; save();
  return phrases[id - 1];
}
